import { cn } from '@shared/lib';

interface ProgressProps {
  total: number;
  current: number;
}

/** Полоски шагов знакомства: пройденные — светлые, текущий — оранжевый. Декоративные. */
export function Progress({ total, current }: ProgressProps) {
  return (
    <div className="mb-8 flex gap-1.5 nav:mb-10" aria-hidden>
      {Array.from({ length: total }, (_, i) => (
        <div
          key={i}
          className={cn(
            'h-[3px] flex-1 rounded-pill transition-colors',
            i < current ? 'bg-fg' : i === current ? 'bg-accent' : 'bg-line',
          )}
        />
      ))}
    </div>
  );
}
